import { render, staticRenderFns } from "./allocationDialog.vue?vue&type=template&id=04a6354a&scoped=true&"
import script from "./allocationDialog.vue?vue&type=script&lang=js&"
export * from "./allocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./allocationDialog.vue?vue&type=style&index=0&id=04a6354a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6354a",
  null
  
)

export default component.exports